import { useCallback, useEffect, useState } from 'react'

const useHiddenFormElements = (selector: string) => {
  const query = useCallback(() => [...document.querySelectorAll(selector)] as HTMLElement[], [selector])

  const [elements, setElements] = useState<HTMLElement[]>(query)
  useEffect(() => {
    const interval = setInterval(
      () => setElements(query),
      100
    )
    return () => clearInterval(interval)
  }, [query])

  return elements
}

export default useHiddenFormElements
